import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  imports: [CommonModule],
  selector: 'app-btn-normal',
  templateUrl: './btn-normal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./btn-normal.component.scss']
})
export class BtnNormalComponent {
  @Input() contentBtn = "";
  @Input() typeBtn: "button" | "submit" = "button";
  @Input() colorBtn = "#a5352a";
  @Input() activeBg = false;
  @Input() showImg = false;
  @Input() icon: '' | 'trash' | 'send' | 'search' | 'download' = '';
  @Input() disabled = false;
  bgColor = `background: ${this.colorBtn};`;
}
